<template>
  <v-container>
    <v-row cols="12" class="justify-center">
      <v-col sm="6">
        <!-- <v-col sm="12" class="py-8">
          <div class="text-4xl text-center font-weight-bold">
            AccountExec
          </div>
        </v-col> -->
        <v-col sm="12" >
          <div class="mx-auto" >
              <img
                class="mx-auto"
                lazy-src="../../public/logo_with_tm.png"
                height="350"
                width="350"
                src="../../public/logo_with_tm.png"
              />
          </div>
          <div class="text text-center text-3xl mt-5 pt-8">
            Make the Most of Your Sales Ecosystem
          </div>
        </v-col>
        <v-form @submit.prevent="handleSubmit()">
          <v-container fluid>
            <v-row>
              <v-col cols="12" >
                <v-alert  type="error" v-if="loginFailed">
                  Login failed - please check your credentials and try again.
                </v-alert>
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="email"
                  required
                  :rules="[required, mustBeEmail]"
                  label="Email"
                  clearable
                  name="email"
                  :disabled="sendingLoginRequest"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="password"
                  required
                  :rules="[required]"
                  label="Password"
                  clearable
                  name="password"
                  type="password"
                  :disabled="sendingLoginRequest"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  class="white--text" color="blue"
                  type="submit"
                  name="submit"
                  :disabled="!formIsValid || sendingLoginRequest"
                  block
                >
                  Login
                </v-btn>
              </v-col>

            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
// @ is an alias to /src

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
        sendingLoginRequest: false,
        loginFailed: false,
        email: '',
        password: '',
        emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
        redirection: {
          eula: '/eula',
          changePassword: '/change_password',
          landing: '/landing'
        }
    }
  },
  methods: {
    required (value) {
        return value !== '' ? true : 'Required'
    },
    mustBeEmail (value) {
        return this.emailRegex.test(value) ? true : 'Must be a valid email'
    },
    validateBeforeSubmit () {
        return this.required(this.email) === true && this.required(this.password) === true && this.mustBeEmail(this.email) === true
    },
    handleSubmit () {
        const { email, password } = this

        if (this.validateBeforeSubmit()) {
            this.loginFailed = false;
            this.sendingLoginRequest = true;
            axios.post(`${this.$store.getters.baseURL}/api/user/login/`, {
                email, password
            })
            .then(res => {
                const { email, id, token, accepted_eula, force_password_reset } = res.data
                const mustAcceptEula = !accepted_eula
                
                this.$store.commit('setToken', token)
                this.$store.commit('setUserData', {email, id, accepted_eula, force_password_reset})

                this.sendingLoginRequest = false;
                let target = 'landing'
                if (mustAcceptEula) {
                  target = 'eula'
                } else if (force_password_reset) {
                  target = 'changePassword'
                } 
                this.$router.push(this.redirection[target]).catch(() => {});
              })
            .catch(err => {
                console.error(err)
                this.loginFailed = true;
                this.sendingLoginRequest = false;
            })
        }
    },
},
  computed: {
    formIsValid () {
      return this.validateBeforeSubmit()
    }
  }
}
</script>

<style scoped>

.font-weight-bold {
  font-weight: 600;
}

.font-weight-extra-thin {
  font-weight: 200;
}
</style>
